import { Component } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { formatarData } from 'src/app/core/utils/utilities';
import { Router } from '@angular/router';
import { debounceTime } from 'rxjs';
import { IGetEngatesOrDesengatesParams } from 'src/app/services/EngateDesengateService/engateDesengate.model';
import { EngateDesengateService } from 'src/app/services/EngateDesengateService/engateDesengate.service';
import { ITabelaDesengates } from './listagem-desengates-model';
import { IGetReportBase64 } from 'src/app/services/ReportService/report.model';
import { AppExportBase64 } from 'src/app/services/ExportBase64/exportBase64.service';
import { ImpressoraService } from 'src/app/services/ImpressoraService/impressora.service';

type IOptions = {
  value: string;
  name: string;
};

@Component({
  selector: 'app-listagem-desengates',
  templateUrl: './listagem-desengates.component.html',
  styleUrls: ['./listagem-desengates.component.scss']
})
export class ListagemDesengatesComponent {
  form = this.initForm();
  tableData: ITabelaDesengates[] | Array<any> = [];
  paginaAtual: number = 1;
  maxPages: number = 1;
  expandirCardsMobile: boolean = true;
  isLoading: boolean = false;

  situacaoOptions: IOptions[] = [
    { name: 'Em Aberto', value: '1' },
    { name: 'Finalizado', value: '2' },
    { name: 'Parcialmente Engatado', value: '3' }
  ];

  tableColumns = [
    { header: 'Código', key: 'idDesengate', type: 'text' },
    { header: 'Nº do Agendamento', key: 'agendamento', type: 'text' },
    { header: 'Empresa', key: 'empresa', type: 'text' },
    { header: 'Data Entrada', key: 'dataEntrada', type: 'text' },
    { header: 'Data Desengate', key: 'dataDesengate', type: 'text' },
    { header: 'Placa Desengate', key: 'placaDesengate', type: 'text' },
    { header: 'Motorista', key: 'motorista', type: 'text' },
    { header: 'Situação', key: 'situacao', type: 'text' },
    {
      header: 'Ações',
      key: 'actions',
      type: 'buttons',
      buttons: [
        {
          label: 'Visualizar',
          img: 'assets/eye-icon.png',
          action: (item: any) => this.visualizarDesengate(item)
        },
        {
          label: 'Download Ticket',
          img: 'assets/icon-download.svg',
          action: (item: any) => this.downloadTicket(Number(item.idDesengate))
        },
        {
          label: 'Impressão Ticket',
          img: 'assets/icon-print.svg',
          action: (item: any) => this.imprimirTicket(Number(item.idDesengate))
        }
      ]
    }
  ];

  constructor(
    private router: Router,
    private fb: FormBuilder,
    private engateDesengateService: EngateDesengateService,
    private appExportBase64: AppExportBase64,
    private impressoraService: ImpressoraService
  ) {}

  ngOnInit() {
    this.getDesengates();
  }

  initForm() {
    const form = this.fb.group({
      FK_AGND: [null],
      NM_EPSA: [null],
      NM_MTRT: [null],
      TX_PLCA_CAVA: [null],
      DT_INIC: [null],
      DT_FIM: [null],
      NU_STTS: [0]
    });
    return form;
  }

  ngAfterViewInit(): void {
    this.form.valueChanges.pipe(debounceTime(300)).subscribe(() => {
      this.getDesengates();
    });
  }

  navegarNovoDesengate() {
    this.router.navigate(['cadastro/desengate']);
  }

  mudarPagina(pagina: number) {
    this.paginaAtual = pagina + 1;
    this.getDesengates();
  }

  getDesengates(): void {
    this.isLoading = true;
    const params = this.createParams();
    this.engateDesengateService.GetEngateOrDesengates(params).subscribe({
      next: res => {
        const data = res.ITEMS;
        this.tableData = data.map(item => {
          const placas = [];

          if (item.TX_PLCA_CRRT1 !== null) placas.push(item.TX_PLCA_CRRT1);
          if (item.TX_PLCA_CRRT2 !== null) placas.push(item.TX_PLCA_CRRT2);
          if (item.TX_PLCA_CRRT3 !== null) placas.push(item.TX_PLCA_CRRT3);

          const placaCarreta = placas.join(' | ');

          return {
            idDesengate: item.PK_ENGT_DSGT,
            agendamento: item.FK_AGND,
            dataEntrada: formatarData(item.DT_GATE_ENTR),
            dataDesengate: formatarData(item.DT_ENGT_DSGT),
            placaDesengate: placaCarreta,
            motorista: item.NM_MTRT,
            situacao: item.FL_STTS,
            empresa: item.NM_EPSA ?? '---'
          };
        });
        this.maxPages = res.TOTAL_PAGES;
        this.isLoading = false;
      },
      error: (err: any) => {
        this.isLoading = false;
      }
    });
  }

  createParams(): IGetEngatesOrDesengatesParams {
    return {
      FL_ENGT: false,
      PAGE_NUMBER: this.paginaAtual,
      PAGE_SIZE: 8,
      NM_EPSA: this.form.controls['NM_EPSA'].value,
      NM_MTRT: this.form.controls['NM_MTRT'].value,
      TX_PLCA_CAVA: this.form.controls['TX_PLCA_CAVA'].value,
      DT_INIC: this.form.controls['DT_INIC'].value,
      DT_FIM: this.form.controls['DT_FIM'].value,
      NU_STTS: this.form.controls['NU_STTS'].value,
      FK_AGND: this.form.controls['FK_AGND'].value
    };
  }

  visualizarDesengate(item: any) {
    const queryParams = {
      ...item,
      isViewing: true
    };
    this.router.navigate(['cadastro/desengate'], {
      queryParams: queryParams
    });
  }

  downloadTicket(id: number) {
    this.isLoading = true;

    this.engateDesengateService.GetReceiptDesengateById(id, 0).subscribe({
      next: (response: IGetReportBase64) => {
        this.appExportBase64.downloadPDF(response.ReportBase64, 'ticket');
        this.isLoading = false;
      },
      error: _error => {
        this.isLoading = false;
      }
    });
  }

  imprimirTicket(id: number) {
    this.isLoading = true;

    this.engateDesengateService.GetReceiptDesengateById(id, 1).subscribe({
      next: (response: IGetReportBase64) => {
        this.isLoading = false;
        this.impressoraService.impressoraTicket(
          response.ReportBase64,
          'text/plain'
        );
      },
      error: _error => {
        this.isLoading = false;
      }
    });
  }

  onSituacaoChange(event: number): void {
    if (event !== this.form.controls['NU_STTS'].value) {
      this.form.controls['NU_STTS'].setValue(event);
    }
  }
}
